<template>
<div
  class="lamp-terml"
  style="margin: 0.5cm;"
>
  <p style="color: #aaaaaa; margin-bottom: 0.1cm; text-align: right; font-size: 5pt;">
    {{ `${ticket.eventId}-${ticket._id}` }}
  </p>

  <h5 class="text-center">Termo de Responsabilidade</h5>
  <p>
    A {{ fullname }} com sede na {{ address.streetType }} {{ address.street }}, nº {{ address.number }} – {{
    address.neighborhood }}, {{ address.city }}/{{ address.state }} inscrita no CNPJ/MF sob o nº. {{ cnpj }} e Inscrição
    Estadual nº. {{ numberState }}, e o(a) Sr(a). {{ payload.customer.holder }}, C.P.F.: {{ payload.customer.cpf }}, e
    N.I.S./N.I.T./N.B. {{ payload.customer.nis }}
    <span v-if="payload.customer.nis === ''">N/C</span> residente e domiciliado (a) na {{
    payload.customer.address.street }} nº {{ payload.customer.address.number }} UC n.º {{ payload.customer.uc }} firmam
    o presente Termo de Responsabilidade, cujas condições, declarações e compromissos assumidos e acordados encontram-se
    descritos a seguir:
  </p>
  <h4>Cláusula Primeira &#8212; CONSIDERAÇÕES PRELIMINARES</h4>
  <ol>
    <li>
      A {{ fullname }} está desenvolvendo o
      <i>“{{ projectName }}”</i>
      que tem por objetivo estabelecer um canal de comunicação com as comunidades por meio de atividades
      socioeducativas para disseminação de conceitos e práticas relacionadas ao uso racional e seguro da energia
      elétrica e orientações na resolução dos problemas sociais nas comunidades;
    </li>
    <li>
      No tocante as praticas relacionadas ao uso racional de energia elétrica, enquadra-se, como tal, o uso de
      lâmpadas econômicas;
    </li>
    <li>
      A {{ fullname }} busca viabilizar essa prática nas comunidades atendidas pelo
      <i>“{{ projectName }}”</i>
      , entre outras ações, disponibiliza lâmpadas econômicas para serem substituídas nas unidades consumidoras
      atendidas, nas condições constadas na <strong>Cláula Segunda</strong>.
    </li>
  </ol>
  <h4>Cláusula Segunda &#8212; CONDIÇÕES E EFETIVAÇÃO DA SUBSTITUIÇÃO</h4>
  <ol>
    <li>
      A {{ fullname }} fornecerá à unidade consumidora atendida pelo projeto a quantidade de
      {{ payload.lamps.length }} lâmpadas LED de potência {{ powerLampDeliveryLabel }}W,
      que serão substituídas por
      <span v-if="numFluorescentLampsReceived > 0">
          {{ numFluorescentLampsReceived }} lâmpadas fluorescentes de potência {{ powerFluorescentLampsReceived }}
        </span>
      <span v-if="numFluorescentLampsReceived > 0 && numIncandescentBulbsReceived > 0">e
        </span>
      <span v-if="numIncandescentBulbsReceived > 0">
          {{ numIncandescentBulbsReceived }} incandescentes de potência {{ powerIncandescentBulbsReceived }}
        </span>, devendo estas ser entregues à {{ abbreviation }} no ato da substituição;
    </li>
    <li>
      O usuário só receberá a quantidade de lâmpadas igual a quantidade entregue à {{ abbreviation }} para substituição
    </li>
    <li>
      O usuário afirma, neste ato, que não possui ligação clandestina, e se compromete a manter-se em dia com o
      parcelamento firmado com a {{ fullname }}.
    </li>
  </ol>
  <h4>Cláusula Terceira &#8212; DAS OBRIGAÇÕES DO USUÁRIO</h4>
  <ol>
    <li>
      O usuário se obriga a não comercializar (vender, trocar, emprestar, dar, ou qualquer outra ação) as lâmpadas
      recebidas. Em caso de descumprimento terá todos os benefícios oriundos do “ {{ projectName }} ” suspensos;
    </li>
    <li>
      O usuário, desde já, autoriza a inspeção pelos funcionários da {{ fullname }} para verificação da
      quantidade/estado das lâmpadas substituídas, e em caso de irregularidade , terá todos os benefícios oriundos do
      “{{ projectName }}” suspensos;
    </li>
  </ol>
  <ol style="margin-top: .5cm;">
    <li>Quantas lâmpadas ficma ligadasno horário das 17:30 às 20:30? _____________
    </li>
    <li>Quantas horas diariamente as lâmpadas ficam ligadas em sua residência? _____________
    </li>
  </ol>
  <div>
    <SignatureCustomerTicket :customer="payload.customer"></SignatureCustomerTicket>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SignatureCustomerTicket from '../../SignatureCustomerTicket'

export default {
  name: 'lamp-term-iasc-ma',
  components: {
    SignatureCustomerTicket
  },

  props: {
    ticket: {
      default: () => Object.assign({})
    },

    payload: {
      default: () => Object.assign({})
    },

    powerLampDeliveryLabel: {
      required: true,
      type: String
    }
  },

  data () {
    return {
      numIncandescentBulbsReceived: 0,
      powerIncandescentBulbsReceived: '',
      numFluorescentLampsReceived: 0,
      powerFluorescentLampsReceived: ''
    }
  },

  computed: {
    ...mapGetters('lamps', ['lampsTmp']),

    numLedLampsDelivered: function () {
      return this.lampsTmp.length
    },

    fullname: function () {
      return this.longname + ' - ' + this.abbreviation
    },
    longname: function () {
      return 'Companhia Energética do Maranhão'
    },
    abbreviation: function () {
      return 'CEMAR'
    },
    projectName: function () {
      return 'IASC 2019'
    },
    fulladdress: function () {
      return `${this.address.type} ${this.address.street}, nº ${this.address.number} – ${this.address.neighborhood}, ${this.address.city}/${this.address.state}`
    },
    address: function () {
      return {
        type: 'Alameda',
        street: 'Alameda A, Quadra SQS',
        number: '100',
        neighborhood: 'Loteamento Quintadinha',
        city: 'Altos do Calhau',
        state: 'MA'
      }
    },
    cnpj: function () {
      return '06.272.793/0001-84'
    },
    numberState: function () {
      return '06.105.848-3'
    }
  },

  mounted () {
    // this.resetOne()
    this.setValues()
  },

  methods: {
    ...mapActions('customers', ['resetOne']),

    setValues () {
      for (let lamp of this.payload.lamps) {
        if (lamp.type === 'Fluorescente') {
          this.numFluorescentLampsReceived++
          this.powerFluorescentLampsReceived += this.numFluorescentLampsReceived === 1 ? `${lamp.power}W` : `, ${lamp.power}W`
        } else if (lamp.type === 'Incandescente') {
          this.numIncandescentBulbsReceived++
          this.powerIncandescentBulbsReceived += this.numIncandescentBulbsReceived === 1 ? `${lamp.power}W` : `, ${lamp.power}W`
        }
      }
    }
  }
}
</script>

<style scoped>
  .fields {
    font-weight: bold;
  }

  p, li {
    font-size: 9pt;
    text-align: justify;
  }

  @page {
    size: auto;   /* auto is the current printer page size */
    margin: 1cm;  /* this affects the margin in the printer settings */
  }
</style>



// WEBPACK FOOTER //
// src/pages/Documents/Terms/IascMa/LampTermIasc.vue